<div style="position: relative" [id]="uniqueId">
    <div class="direction-input" (click)="toggleDropdown()" (keyup.enter)="toggleDropdown()">
        <img class="address-icon" src="../../../assets/icons/location-marker.svg" alt="" />
        <input id="address" [(ngModel)]="address" [placeholder]="placeholder" (input)="onInputChange()"
            autocomplete="off" />
    </div>
    <div *ngIf="addressesListOptions.length > 0 && dropdownOpen"
        [ngClass]="absoluteDropdown ? 'absolute-dropdown' : 'inline-dropdown' " class="autocomplete-suggestions">

        <div class="scrollable-content">
            <div *ngFor="let option of addressesListOptions; let last = last"
                [ngClass]="{'border-bottom-option': !last}" class="address-option"
                (click)="onSuggestionSelected(option)">
                <img [src]="option.icon" alt="" />
                <p>
                    <span class="address-option-name">{{ option?.name }}</span><span
                        [ngClass]="!option?.name ? 'address-option-name' : 'address-option-address'"> {{
                        option.address }}</span>
                </p>
            </div>
        </div>

    </div>
</div>